<template>
  <div class="relative w-full">
    <img
            v-if="items.length === 0"
            :class="`w-full h-auto object-cover rounded-img aspect-16/9`"
            alt="Placeholder Image"
            src="https://placehold.co/600x400?text=Enerwin+Aermec"
    >
    <picture
            v-else-if="items.length === 1"
            :class="pictureClass"
            class="block"
    >
      <media-source
              :dimensions="imgDimensions"
              :sizes="imgSizes"
              :uri="items[0]!.url"
              as="source"
              format="webp"
      />
      <media-source
              :alt="altText"
              :class-name="`${imgClass} ${getAspectClass(items[0]!)}`"
              :dimensions="imgDimensions"
              :sizes="imgSizes"
              :uri="items[0]!.url"
              as="img"
              format="jpg"
      />
    </picture>
    <swiper
            v-else-if="items.length > 1"
            :auto-height="true"
            :modules="[Navigation]"
            :pagination="{
                clickable: true,
            }"
            :space-between="16"
            slides-per-view="auto"
            @swiper="onSwiper"
            @slide-change="refreshNavigationVisibility"
    >
      <swiper-slide
              v-for="image in items"
              :key="image.url"
              class=""
      >
        <picture
                :class="pictureClass"
                class="mb-0"
        >
          <media-source
                  :dimensions="imgDimensions"
                  :sizes="imgSizes"
                  :uri="image.url"
                  as="source"
                  format="webp"
          />
          <media-source
                  :alt="altText"
                  :class-name="imgClass + ' ' + getAspectClass(image)"
                  :dimensions="imgDimensions"
                  :sizes="imgSizes"
                  :uri="image.url"
                  as="img"
                  format="jpg"
          />
        </picture>
      </swiper-slide>
    </swiper>
    <div
            v-if="items.length > 1"
            class="flex justify-end gap-2 absolute bottom-2 end-2 z-10"
    >
      <button
              :disabled="isBeginning"
              class="disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-white disabled:text-brand disabled:translate-x-0 cursor-pointer p-3 bg-white hover:bg-brand text-brand hover:text-white transition-all hover:-translate-x-1 rounded-full"
              @click="slidePrev">
        <ArrowLeftIcon class="size-6"/>
      </button>
      <button
              :disabled="isEnd"
              class="disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-white disabled:text-brand disabled:translate-x-0 cursor-pointer p-3 bg-white hover:bg-brand text-brand hover:text-white transition-colors hover:translate-x-1 rounded-full"
              @click="slideNext">
        <ArrowRightIcon class="size-6"/>
      </button>
    </div>
  </div>
</template>
<script lang="ts" setup>
import {Navigation} from "swiper/modules";
import {Swiper, SwiperSlide} from "swiper/vue";
import {ArrowLeftIcon, ArrowRightIcon} from "@heroicons/vue/16/solid";

const {
    items,
    altText = '',
    imgDimensions = [
        {width: 480},
        {width: 960},
        {width: 1440},
        {width: 1920},
    ],
    imgSizes = '50vw',
    pictureClass = '',
    imgClass = 'w-full h-auto object-cover rounded-img'
} = defineProps<{
    items: {
        url: string,
        width?: number,
        height?: number,
    }[],
    altText?: string,
    imgDimensions?: { width: number }[],
    imgSizes?: string,
    pictureClass?: string,
    imgClass?: string,
}>();
const swiperInstance = ref();
const isBeginning = ref<boolean>(true);
const isEnd = ref<boolean>(false);
const onSwiper = (swiper: any) => {
    swiperInstance.value = swiper;
    refreshNavigationVisibility();
};
const slideNext = () => {
    swiperInstance.value?.slideNext();
};
const slidePrev = () => {
    swiperInstance.value?.slidePrev();
};

function refreshNavigationVisibility() {
    nextTick().then(() => {
        if (swiperInstance.value) {
            isBeginning.value = swiperInstance.value.isBeginning;
            isEnd.value = swiperInstance.value.isEnd;
        }
    });
}

function getAspectClass(image: { url: string, width?: number, height?: number }) {
    if (!image.width || !image.height) return '';
    return `aspect-[${image.width}/${image.height}]`;
}
</script>